import { Inject, Injectable } from '@angular/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { WorkWeekdayModel, WorkWeekdayModelFromJson } from '../../models/complex/work-weekday.model';
import { ConcurrentUsageService } from '../concurrent-usage/concurrent-usage.service';

const WEEKLY_WORK_MODEL_KEY = 'WeeklyWorkHour';

@Injectable({
    providedIn: 'root',
})
export class WeeklyWorkTimeConcurrentStorageService {
    public constructor(
        private readonly concurrentUsageService: ConcurrentUsageService,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
    ) {}

    public getWeeklyWorkModel(): Observable<WorkWeekdayModel> {
        return this.concurrentUsageService.readDataForKey(WEEKLY_WORK_MODEL_KEY).pipe(
            map((data) => {
                if (data?.length > 0) {
                    return new WorkWeekdayModelFromJson(JSON.parse(data[0].value));
                }
                this.log.debug(
                    '[Concurrency Store WeeklyWorkModel]: Work time was not found, creating new WeeklyWorkModel',
                );
                return new WorkWeekdayModel([]);
            }),
            catchError((error) => {
                this.log.warn(
                    `[Concurrency Store WeeklyWorkModel] : Couldn't load value. Error: ${error} creating new WeeklyWorkModel`,
                );
                return of(new WorkWeekdayModel([]));
            }),
        );
    }

    public saveWeeklyWorkModel(weeklyWorkList: WorkWeekdayModel): Observable<WorkWeekdayModel> {
        return this.concurrentUsageService
            .writeDataForKey(WEEKLY_WORK_MODEL_KEY, JSON.stringify(weeklyWorkList), Date.now())
            .pipe(
                map(() => weeklyWorkList),
                catchError((error) => {
                    this.log.debug(
                        `[Confirmation Concurrency Store] saveWeeklyWorkModel: could not write to WeeklyWorkModel to concurrency store: ${JSON.stringify(
                            error,
                        )}`,
                    );
                    return of(weeklyWorkList);
                }),
            );
    }
}
